import {createStyles} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

import type {FlowchartVersionData} from './PMEIMaterialLinkUtils';
import PMEISidePanelContent from './PMEISidePanelContent';
import PMEISidepanelHeader from './PMEISidepanelHeader';
import usePMEISidepanelDetail from './usePMEISidepanelDetail';
import {UnitOperationFields} from './useUnitOpLinkingState';

const useStyles = createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

export default function PMEISidePanel({
  unitOperation,
  onNavigateToPmei,
  flowchartData,
  pmeiIdToUnitOperationFields,
}: {
  unitOperation: UnitOperationFields;
  onNavigateToPmei: ((pmeiId: string) => void) | null;
  flowchartData: FlowchartVersionData | null;
  pmeiIdToUnitOperationFields: Map<string, UnitOperationFields>;
}): JSX.Element {
  const detail = usePMEISidepanelDetail(unitOperation.pmeiId, flowchartData, pmeiIdToUnitOperationFields);
  const {classes} = useStyles();

  return (
    <div className={classes.root} {...getTestProps({component: 'PMEISidePanel', element: 'root'})}>
      <PMEISidepanelHeader unitOperation={unitOperation} />
      <PMEISidePanelContent
        detailData={detail.data}
        loading={detail.loading}
        onNavigateToPmei={onNavigateToPmei}
      />
    </div>
  );
}
